import React, { Component } from "react";
import { Grid, Divider, Header, Segment } from "semantic-ui-react";

import FormsUserPreferences from "../preferences";
import FormsUserPassword from "../password";

// Container only. Name and email are read-only, and the two editable concerns
// are separate forms with separate buttons: saving a notification preference
// must not require a password, and changing a password requires an emailed code.
class FormsUserUpdate extends Component {
  render() {
    const { user } = this.props;
    return (
      <div style={{ padding: 20 }}>
        <Grid container columns={2}>
          <Grid.Column width={16}>
            <Divider horizontal>Update My Profile</Divider>
          </Grid.Column>
          <Grid.Column>
            <Header sub>NAME</Header>
            <Segment secondary>{user.name}</Segment>
          </Grid.Column>
          <Grid.Column>
            <Header sub>EMAIL</Header>
            <Segment secondary>{user.email}</Segment>
          </Grid.Column>
        </Grid>
        <FormsUserPreferences user={user} />
        <FormsUserPassword user={user} />
      </div>
    );
  }
}

export default FormsUserUpdate;
